export default __webpack_public_path__ + "assets/images/3084f0fc7b2ec06aa0302fd1b80517c2.png";